(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  var TITLE_SELECTOR = '.footer__block-linklist .footer__block__title';
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function bindFooterAccordions() {
    document.querySelectorAll(TITLE_SELECTOR).forEach(function (title) {
      if (title.dataset.footerAccordionBound) return;
      title.dataset.footerAccordionBound = 'true';

      title.addEventListener('click', function () {
        // Only act as an accordion at the mobile breakpoint, where the CSS
        // collapses .footer__quicklinks to max-height:0.
        if (!mobileQuery.matches) return;

        this.classList.toggle('active');

        var panel = this.nextElementSibling;
        if (!panel) return;

        panel.style.maxHeight = panel.style.maxHeight ? null : panel.scrollHeight + 'px';
      });
    });
  }

  // Leaving the mobile breakpoint (e.g. landscape rotation / resize) must clear
  // any inline max-height, otherwise an expanded panel would clamp the desktop
  // footer list. Also drop the active (minus-icon) state.
  function resetOnDesktop() {
    if (mobileQuery.matches) return;
    document.querySelectorAll(TITLE_SELECTOR).forEach(function (title) {
      title.classList.remove('active');
      var panel = title.nextElementSibling;
      if (panel) panel.style.maxHeight = null;
    });
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', resetOnDesktop);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(resetOnDesktop); // Safari < 14
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindFooterAccordions);
  } else {
    bindFooterAccordions();
  }

  // Re-bind when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', bindFooterAccordions);
})();

  } catch(e) { console.error(e); }
})();
})();
